// extracted by mini-css-extract-plugin
export default {"logotag":"newheader_logotag__u8nQa"};